import AbstractQuery from "api/lib/abstract_query/interfaces/AbstractQuery";
import DataType from "api/lib/abstract_query/interfaces/DataType";
import Func from "api/lib/abstract_query/interfaces/Func";
import FunctionName from "api/lib/abstract_query/interfaces/FunctionName";
import FunctionUtils from "api/lib/abstract_query/FunctionUtils";
import ResultColumn from "api/lib/abstract_query/interfaces/ResultColumn";
import ResultColumnType from "api/lib/abstract_query/interfaces/ResultColumnType";
import ResultColumnFactory from "api/lib/abstract_query/ResultColumnFactory";
import ColumnObject from "api/lib/data/interfaces/ColumnObject";
import VersionSuccessResult from "api/lib/data/interfaces/VersionSuccessResult";
import * as _ from "lodash";
import * as React from "react";
import { Icon, Label, List, Popup } from "semantic-ui-react";

export interface IDataTableProps {
  abstractQuery: AbstractQuery;
  response: VersionSuccessResult;
  orgId: string;
  datasourceId: string;
  handleAddColumn: (
    tableName: string,
    column: ColumnObject,
    metadata: any
  ) => void;
  handleAggregationChanged: (
    columnIndex: number,
    aggregation: FunctionName
  ) => void;
  handleRemoveColumn: (columnIndex: number) => void;
  showSchema: () => void;
}

export interface IDataTableState {
  column: any;
  sortedData: any[];
  direction: "ascending" | "descending" | undefined;
  isHovered: any;
}

export default class DataTable extends React.Component<
  IDataTableProps,
  IDataTableState
> {
  private static INITIAL_STATE = {
    column: null,
    direction: undefined,
    isHovered: {},
    sortedData: [],
  };
  constructor(props: IDataTableProps) {
    super(props);

    this.state = { ...DataTable.INITIAL_STATE };
  }
  public componentDidMount = () => {
    const { response } = this.props;
    if (response && response.data) {
      this.setState({ sortedData: response.data });
    }
  };

  public componentDidUpdate = (prevProps, prevState) => {
    if (
      JSON.stringify(this.props.response.data) !==
      JSON.stringify(prevProps.response.data)
    ) {
      const { response } = this.props;
      if (response && response.data) {
        this.setState({ sortedData: response.data });
      }
    }
  };

  public render() {
    const { abstractQuery, showSchema } = this.props;
    // const { sortedData } = this.state;
    // margin-top: 11px;height: calc(100% - 45px);overflow-y: auto;overflow-x: hidden;margin-bottom: 0;
    return (
      <React.Fragment>
        <List
          className="selected-cols-list"
          style={{
            marginTop: "11px",
            height: "calc(100% - 45px)",
            marginBottom: "0px",
          }}
        >
          {_.map(abstractQuery.columns, (head, headerIndex) => (
            <List.Item
              key={`col${headerIndex}`}
              style={{
                width: "230px",
                padding: "0",
              }}
            >
              <Label
                onMouseEnter={() => this.handleMouseEnter(headerIndex)}
                onMouseLeave={() => this.handleMouseLeave(headerIndex)}
                style={{
                  background: "0 0",
                  fontSize: "13px",
                  padding: "0px",
                  margin: "0px",
                }}
              >
                {this.renderHeaderCell(headerIndex)}
              </Label>
            </List.Item>
          ))}
        </List>
        <div
          style={{
            position: "absolute",
            zIndex: 1,
            bottom: "10px",
            left: "23px",
          }}
        >
          {this.props.datasourceId && <a onClick={showSchema}>Show schema </a>}
          {/* <Button basic={true} size="small" content="Add column" /> */}
        </div>
        {/* 
        <Table
          sortable={true}
          celled={true}
          fixed={true}
          striped={true}
          compact={true}
          size="small"
        >
          <Table.Header>
            <Table.Row>
             
              {abstractQuery.columns.length > 0 && (
                <Table.HeaderCell
                  style={{ overflow: "visible", height: "50px" }}
                >
                  <BrowseColumns
                    orgId={orgId}
                    datasourceId={datasourceId}
                    addColumn={handleAddColumn}
                    showOnlyIcon={false}
                  />
                </Table.HeaderCell>
              )}
              {abstractQuery.columns.length === 0 && (
                <React.Fragment>
                  <Table.HeaderCell
                    style={{ overflow: "visible", height: "50px" }}
                  >
                    <BrowseColumns
                      orgId={orgId}
                      datasourceId={datasourceId}
                      addColumn={handleAddColumn}
                    />
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    style={{ overflow: "visible", height: "50px" }}
                  >
                    {""}
                  </Table.HeaderCell>
                </React.Fragment>
              )} 
            </Table.Row>
          </Table.Header>

          {/* <Table.Body>
            {_.map(sortedData, (row, index) => (
              <Table.Row key={index}>
                {_.map(abstractQuery.columns, (head, headerIndex) => (
                  <Table.Cell key={headerIndex}>{row[headerIndex]}</Table.Cell>
                ))}

                {/* <Table.Cell key="newColumn1">{""}</Table.Cell> 
              </Table.Row>
            ))}
            {abstractQuery.columns.length === 0 &&
              _.map(
                ["", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                (row, index) => (
                  <Table.Row key={index}>
                    <Table.Cell key="newColumn2">
                      <span
                        style={{ textIndent: "-123213px", display: "inherit" }}
                      >
                        {"xxx"}
                      </span>
                    </Table.Cell>
                    {/* <Table.Cell key="newColumn3">
                      <span
                        style={{ textIndent: "-123213px", display: "inherit" }}
                      >
                        {"xxx"}
                      </span>
                    </Table.Cell>              </Table.Row>
                )
              )}

            {abstractQuery.columns.length > 0 &&
              _.map(
                ["", "", "", "", "", "", "", "", "", "", "", "", "", "", ""],
                (row, index) => (
                  <Table.Row key={index}>
                    {_.map(abstractQuery.columns, (column, columnIndex) => {
                      return (
                        <Table.Cell key={`newColumn2${columnIndex}`}>
                          <span
                            style={{
                              textIndent: "-123213px",
                              display: "inherit",
                            }}
                          >
                            {"xxx"}
                          </span>
                        </Table.Cell>
                      );
                    })}
                    {/* <Table.Cell key={`newColumn2Add`}>
                      <span
                        style={{
                          textIndent: "-123213px",
                          display: "inherit",
                        }}
                      >
                        {"xxx"}
                      </span>
                    </Table.Cell> 
                  </Table.Row>
                )
              )}
          </Table.Body> 
        </Table>*/}
      </React.Fragment>
    );
  }

  private handleMouseEnter = (index: number) => {
    this.setState((prevState) => {
      return { isHovered: { ...prevState.isHovered, [index]: true } };
    });
  };

  private handleMouseLeave = (index: number) => {
    this.setState((prevState) => {
      return { isHovered: { ...prevState.isHovered, [index]: false } };
    });
  };

  private renderHeaderCell = (columnIndex: number) => {
    const { abstractQuery } = this.props;
    const resultColumn: ResultColumn = abstractQuery.columns[columnIndex];
    if (resultColumn.type === ResultColumnType.FORMULA) {
      return <React.Fragment>{resultColumn.alias}</React.Fragment>;
    }

    const isFunction = resultColumn.type === ResultColumnType.FUNC;
    let aggregation = null;
    if (isFunction) {
      const func1: Func = resultColumn as Func;
      aggregation = func1.name.valueOf();
    }
    const dropDownTrigger = (
      <div style={{ display: "inline-block" }}>
        {this.getColumnIcon(resultColumn)}
        <span
          style={{
            cursor: "pointer",
            display: "inline-block",
            height: "25px",
            lineHeight: "25px",
          }}
        >
          {isFunction && (
            <span
              style={{
                fontStyle: "italic",
                fontWeight: "lighter",
                paddingRight: "5px",
                textTransform: "lowercase",
                display: "inline-block",
                overflow: "hidden",
              }}
            >
              {aggregation}
            </span>
          )}
          <span
            style={{
              display: "inline-block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "148px",
            }}
          >
            {ResultColumnFactory.getColumnName(resultColumn)}
          </span>
        </span>
      </div>
    );
    return (
      <React.Fragment>
        {this.renderDropdown(columnIndex, resultColumn, dropDownTrigger)}
        {this.state.isHovered[columnIndex] && (
          <React.Fragment>
            <Icon
              style={{ float: "right", marginLeft: "5px", width: "25px" }}
              link={true}
              name="trash alternate outline"
              onClick={(e: React.SyntheticEvent) =>
                this.handleRemoveColumn(e, columnIndex)
              }
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  private renderDropdown = (
    columnIndex: number,
    resultColumn: ResultColumn,
    dropDownTrigger: any
  ) => {
    return (
      <React.Fragment>
        <Popup
          trigger={dropDownTrigger}
          flowing={true}
          hoverable={true}
          position="bottom left"
          className="browser-columns-popup"
          on="click"
        >
          <List
            verticalAlign="middle"
            selection={true}
            style={{ maxHeight: "300px", overflowY: "auto" }}
          >
            {this.getAggregationOptions(columnIndex, resultColumn)}
          </List>
        </Popup>
        {/* <Dropdown
          className="table-column-header-dropdown"
          inline={true}
          trigger={dropDownTrigger}
          options={}
          value={func.name.valueOf()}
          onChange={(e: React.SyntheticEvent, data: any) =>
            this.handleChangeAggreation(e, data, columnIndex)
          }
        /> */}
      </React.Fragment>
    );
  };

  private getAggregationOptions = (
    columnIndex: number,
    resultColumn: ResultColumn
  ) => {
    return FunctionUtils.getFunctions(resultColumn.dataType).map(
      (key: FunctionName, index: number) => {
        return (
          <List.Item
            key={`${key}-${index}`}
            onClick={() => {
              this.handleChangeAggreation(columnIndex, key);
            }}
          >
            <List.Content>
              <span
                style={{
                  fontStyle: "italic",
                  paddingRight: "5px",
                  textTransform: "lowercase",
                }}
              >
                {key}
              </span>
            </List.Content>
          </List.Item>
        );
        // return {
        //   key,
        //   text,
        //   value: key,
        // };
      }
    );
  };

  private getColumnIcon = (resultColumn: ResultColumn) => {
    if (resultColumn.metric) {
      return <Icon name="hashtag" className="metric" />;
    } else {
      if (
        [
          DataType.DATE,
          DataType.DATETIME,
          DataType.TIME,
          DataType.TIMESTAMP,
          DataType.TIMESTAMPWITHTIMEZONE,
          DataType.TIMEWITHTIMEZONE,
        ].indexOf(resultColumn.dataType) >= 0
      ) {
        return (
          <Icon name="calendar alternate outline" className="dimension date" />
        );
      } else {
        return <Icon name="font" className="dimension" />;
      }
    }
  };

  private handleRemoveColumn = (
    e: React.SyntheticEvent,
    columnIndex: number
  ) => {
    this.setState({ isHovered: {} });
    this.props.handleRemoveColumn(columnIndex);
  };

  private handleChangeAggreation = (
    columnIndex: number,
    value: FunctionName
  ) => {
    this.setState({ isHovered: {} });
    this.props.handleAggregationChanged(columnIndex, value);
  };
}



// WEBPACK FOOTER //
// ./src/components/Query/DataTable.tsx